/**
 * Función encargada de retornar un número aleatorio en el rango que es pasado por parametro.
 * @param startindex Parametro que recibe el número inical
 * @param endIndex parmaetro que recibe el número final.
 */
const chooseRandomNumer = function (startindex: number, endIndex: number) {
  return Math.floor(Math.random() * (startindex - endIndex)) + endIndex;
};

/**
 * Función encargada de generar una lista de objetos aleatorios tomando como base otra lista, un indice de entrada y otro de salida.
 * @param array Parametro que recibe la lista base
 * @param count Parametro que recibe el tamaño (cantidad de elementos) de la lista a retornar.
 * @param startIndex Parametro que recibe el un número como inicio.
 * @param endIndex Parametro que recibe el index de finalización.
 */
export const getRandomObjectsInRangeSync = function (
  array: any,
  count: number,
  startIndex: number,
  endIndex: number
) {
  if (Array.isArray(array) === false) {
    throw new Error('Invalid array object');
  }
  if (startIndex < 0 || startIndex > array.length - 1) {
    throw new Error('Invalid startIndex value');
  }
  if (endIndex < 0 || endIndex > array.length - 1) {
    throw new Error('Invalid endIndex value');
  }
  if (count < startIndex || count > endIndex - startIndex + 1) {
    throw new Error('Invalid count value');
  }
  const resultList = [];
  let temp, randomIndex;
  while (count > 0 && startIndex <= endIndex) {
    randomIndex = chooseRandomNumer(startIndex, endIndex);
    // Swap the last and the current element
    temp = array[randomIndex];
    array[randomIndex] = array[endIndex];
    array[endIndex] = temp;

    // Push the last element into the resultList
    resultList.push(temp);
    count--;
    endIndex--;
  }
  return resultList;
};
/**
 * Función encargada de generar una lista de objetos aleatorios tomando como base otra lista, un indice de entrada y otro de salida,
 * para esto se apoya de otro método (getRandomObjectsInRangeSync).
 * @param array array Parametro que recibe la lista base
 * @param count Parametro que recibe el tamaño (cantidad de elementos) de la lista a retornar.
 * @param startIndex Parametro que recibe el un número como inicio.
 * @param endIndex Parametro que recibe el index de finalización.
 * @param callback Parametro que recibe un método.
 */
export const getRandomObjectsInRange = function (
  array: any[],
  count: number,
  startIndex: number,
  endIndex: number,
  callback: any
) {
  let resultList = [];
  try {
    resultList = getRandomObjectsInRangeSync(
      array,
      count,
      startIndex,
      endIndex
    );
    callback(null, resultList);
  } catch (err) {
    callback(err, resultList);
  }
};

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
export const dynamicSortAlpha = (property: any) => {
  let sortOrder = 1;

  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }

  return (a: any, b: any) => {
    if (sortOrder === -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  };
};
